module.exports = __webpack_public_path__ + "static/img/ad-7.fe53c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-7.png
// module id = d4kT
// module chunks = 0